/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Grid, Switch, Typography } from "@mui/material";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import SoftTypography from "components/SoftTypography";

const tableStyle = {
  borderCollapse: "collapse",

  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "wrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",

  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};
const dataTable = [
  {
    id: 1,
    stt: "1",
    asset:
      "Miễn kê khai xác định giá giao dịch liên kết tại mục III, mục IV và được miễn lập Hồ sơ xác định giá giao dịch liên kết",
    readOnly: true,
    value: { except: false },
  },
  {
    id: 2,
    stt: "",
    asset:
      "Người nộp thuế chỉ phát sinh giao dịch với các bên liên kết là đối tượng nộp thuế thu nhập doanh nghiệp tại Việt Nam, áp dụng cùng mức thuế suất thuế thu nhập doanh nghiệp với người nộp thuế và không bên nào được hưởng ưu đãi thuế thu nhập doanh nghiệp trong kỳ tính thuế",
    readOnly: false,
    value: { except: false },
  },
  {
    id: 3,
    stt: 2,
    asset: "Miễn lập Hồ sơ xác định giá giao dịch liên kết",
    readOnly: true,
    value: { except: false },
  },
  {
    id: 4,
    stt: "a",
    asset:
      "Người nộp thuế có phát sinh giao dịch liên kết nhưng tổng doanh thu phát sinh của kỳ tính thuế dưới 50 tỷ đồng và tổng giá trị tất cả các giao dịch liên kết phát sinh trong kỳ tính thuế dưới 30 tỷ đồng",
    readOnly: false,
    value: { except: false },
  },
  {
    id: 5,
    stt: "b",
    asset:
      "Người nộp thuế đã ký kết Thỏa thuận trước về phương pháp xác định giá tính thuế thực hiện nộp Báo cáo thường niên theo quy định pháp luật về Thỏa thuận trước về phương pháp xác định giá",
    readOnly: false,
    value: { except: false },
  },
  {
    id: 6,
    stt: "c",
    asset:
      "Người nộp thuế thực hiện kinh doanh với chức năng đơn giản, không phát sinh doanh thu, chi phí từ hoạt động khai thác, sử dụng tài sản vô hình, có doanh thu dưới 200 tỷ đồng, áp dụng tỷ suất lợi nhuận thuần trước lãi vay và thuế thu nhập doanh nghiệp trên doanh thu, bao gồm các lĩnh vực như sau:",
    readOnly: false,
    value: { except: false },
  },
  {
    id: 7,
    stt: "",
    asset: "- Phân phối: Từ 5% trở lên",
    readOnly: false,
    value: { except: false },
  },
  {
    id: 8,
    stt: "",
    asset: "- Sản xuất: Từ 10% trở lên",
    readOnly: false,
    value: { except: false },
  },
  {
    id: 9,
    stt: "",
    asset: "- Gia công: Từ 15% trở lên",
    readOnly: false,
    value: { except: false },
  },
];
export default function TableGDLK01b({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-start">
        <Typography variant="h6">
          MỤC II. CÁC TRƯỜNG HỢP ĐƯỢC MIỄN NGHĨA VỤ KÊ KHAI, MIỄN TRỪ VIỆC NỘP HỒ SƠ XÁC ĐỊNH GIÁ
          GIAO DỊCH LIÊN KẾT
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center", width: 10 }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", minWidth: 400 }}>
                Trường hợp miễn trừ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", minWidth: 200 }}>
                Thuộc diện miễn trừ
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (3)
              </Td>
            </tr>
            {data &&
              data.length > 0 &&
              data.map((rows, index) => (
                <tr key={index}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    style={{
                      textAlign: "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    rowSpan={1}
                    style={{
                      textAlign: "center",
                      maxWidth: 100,
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                    }}
                  >
                    <Switch
                      disabled={rows.readOnly}
                      checked={rows.except}
                      onChange={({ target: { checked } }) =>
                        handleChange({ id: rows.id, value: checked, name: "except" })
                      }
                    />
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, readOnlyBackground, fontWeight, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: readOnlyBackground === true ? "#ddeff3" : "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        minWidth: 180,
        borderRadius: "0.5rem",
        fontWeight: fontWeight,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
